module.exports = __webpack_public_path__ + "img/kkb_strobe.184b75fe.jpg";